var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subs"},_vm._l((_vm.room.subs),function(sub){return _c('MiniEntity',{key:sub.id,attrs:{"entity":sub}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }